// data-email-validate="true" が付与された入力欄に対し、
// メールアドレス形式のバリデーションと、Bootstrapの is-invalid および invalid-feedback を使った
// インラインエラー表示を行います。

(function () {
  'use strict';

  function isValidEmail(value) {
    // Practical, permissive email format check
    // eslint-disable-next-line no-control-regex
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(value);
  }

  function findOrCreateFeedbackElement(input) {
    // Prefer an existing sibling we created before
    let feedback = input.parentElement && input.parentElement.querySelector('.js-email-format-error.invalid-feedback');
    if (!feedback) {
      feedback = document.createElement('div');
      feedback.className = 'invalid-feedback js-email-format-error';
      // Place directly after the input to work with Bootstrap sibling selector
      input.insertAdjacentElement('afterend', feedback);
    }
    return feedback;
  }

  function showError(input, message) {
    input.classList.add('is-invalid');
    input.setAttribute('aria-invalid', 'true');
    const feedback = findOrCreateFeedbackElement(input);
    feedback.textContent = message;
  }

  function clearError(input) {
    input.classList.remove('is-invalid');
    input.removeAttribute('aria-invalid');
    const feedback = input.parentElement && input.parentElement.querySelector('.js-email-format-error.invalid-feedback');
    if (feedback) {
      feedback.textContent = '';
    }
  }

  function attachValidation(input) {
    if (input.dataset.emailValidateBound === '1') return;
    input.dataset.emailValidateBound = '1';

    const form = input.closest('form');

    const validate = () => {
      const value = (input.value || '').trim();
      if (value.length === 0) {
        // 空欄はここでは扱わず（必須チェックはサーバ側や既存バリデーションに委ねる）
        clearError(input);
        return true;
      }
      if (!isValidEmail(value)) {
        showError(input, input.dataset.emailFormatError);
        return false;
      }
      clearError(input);
      return true;
    };

    input.addEventListener('input', validate);
    input.addEventListener('blur', validate);

    if (form) {
      // Guard against multiple bindings on the same form
      if (!form.dataset.emailValidateSubmitBound) {
        form.addEventListener('submit', function (event) {
          // Revalidate all marked inputs within this form
          const targets = form.querySelectorAll('[data-email-validate="true"]');
          let allValid = true;
          targets.forEach((el) => {
            const ok = ((el.value || '').trim().length === 0) ? true : isValidEmail((el.value || '').trim());
            if (!ok) {
              showError(el, el.dataset.emailFormatError);
              if (allValid) {
                // focus the first invalid one
                el.focus();
              }
              allValid = false;
            } else {
              clearError(el);
            }
          });
          if (!allValid) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
        form.dataset.emailValidateSubmitBound = '1';
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-email-validate="true"]').forEach(attachValidation);
  }

  document.addEventListener('turbolinks:load', init);
})();


